export const companyInfoMessageToCreateCompanyRQ = company => {
    const {
        cityName,
        companyCode,
        countryName,
        creationDate,
        currentBalance,
        firstOrderDate,
        groupOfContracts,
        groupOfContractsId,
        id,
        lastOrderDate,
        manager,
        ordersCount,
        registrationDate,
        relationship,
        tagPrefix,
        totalLoyaltyPoints,
        ...putRequest
    } = company
    return putRequest
}

export const companyInfoMessageToUpdateCompanyRQ = company => {
    const {type, ...putRequest} = companyInfoMessageToCreateCompanyRQ(company)
    return putRequest
}
